import { GiveawayDefault } from './GiveawayDefault';
import { LogoLayoutNavbar } from './../Home/components/LogoLayoutNavbar';

GiveawayDefault.Navbar = LogoLayoutNavbar;

export default GiveawayDefault;
